import { doughnutChartData, barChartData } from '../../head-doctor/reports/charts/chartDataHelpers';
import { ALERT_TYPE_CHART_ORDER, ALERT_TYPE_COLORS, alertTypeLabel } from '../components/alertsUi';

function countByKey(items, keyFn) {
  const map = new Map();
  items.forEach((item) => {
    const key = keyFn(item);
    if (!key) return;
    map.set(key, (map.get(key) || 0) + 1);
  });
  return [...map.entries()]
    .map(([label, value]) => ({ label, value }))
    .sort((a, b) => b.value - a.value);
}

export function buildAlertsTypePie(summary = {}) {
  const labels = [];
  const values = [];
  const colors = [];

  ALERT_TYPE_CHART_ORDER.forEach((type) => {
    const key =
      type === 'OUT_OF_STOCK'
        ? 'out_of_stock'
        : type === 'LOW_STOCK'
          ? 'low_stock'
          : type === 'EXPIRED'
            ? 'expired'
            : 'expiring';
    const count = Number(summary[key] || 0);
    if (count <= 0) return;
    labels.push(alertTypeLabel(type));
    values.push(count);
    colors.push(ALERT_TYPE_COLORS[type]);
  });

  if (!labels.length) return null;
  return doughnutChartData(labels, values, colors);
}

export function buildAlertsSiteBar(alerts = [], { limit = 8 } = {}) {
  const rows = countByKey(alerts, (a) => a.site_name).slice(0, limit);
  if (!rows.length) return null;

  const palette = ['#0d9488', '#4338ca', '#0891b2', '#059669', '#d97706', '#dc2626', '#7c3aed', '#64748b'];

  return {
    labels: rows.map((r) => r.label),
    datasets: [
      {
        label: 'Alertes',
        data: rows.map((r) => r.value),
        backgroundColor: rows.map((_, i) => palette[i % palette.length]),
        borderRadius: 8,
        maxBarThickness: 52
      }
    ]
  };
}

export function buildAlertsTypeBar(summary = {}) {
  const labels = [];
  const values = [];
  const colors = [];

  ALERT_TYPE_CHART_ORDER.forEach((type) => {
    const key =
      type === 'OUT_OF_STOCK'
        ? 'out_of_stock'
        : type === 'LOW_STOCK'
          ? 'low_stock'
          : type === 'EXPIRED'
            ? 'expired'
            : 'expiring';
    const count = Number(summary[key] || 0);
    labels.push(alertTypeLabel(type));
    values.push(count);
    colors.push(ALERT_TYPE_COLORS[type]);
  });

  if (!values.some((v) => v > 0)) return null;

  return {
    labels,
    datasets: [
      {
        label: 'Alertes',
        data: values,
        backgroundColor: colors,
        borderRadius: 8,
        maxBarThickness: 52
      }
    ]
  };
}

export function buildTopMedicationBar(alerts = [], { limit = 8 } = {}) {
  const rows = countByKey(alerts, (a) => a.medication_name).slice(0, limit);
  if (!rows.length) return null;
  return barChartData(
    rows.map((r) => r.label),
    rows.map((r) => r.value),
    'Alertes',
    '#4338ca'
  );
}
